<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        
                        <small>Promo Listing filters</small> <br><br>

                        <!-- <div class="row">
                            <div class="col-md-12">
                                <base-input label="Report Type" v-if="selectAllBrand == false">
                                    <a-select
                                        style="width: 100%"
                                        placeholder="Please select"
                                        v-model="promoReportType">
                                        <a-select-option :value="1">Item Report</a-select-option>
                                        <a-select-option :value="2">Location Report</a-select-option>
                                    </a-select> 
                                </base-input>
                            </div>
                        </div> -->

                        <div class="row">
                            <div class="col-md-12">
                                <base-input label="Effectivity Date"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">


                                <base-checkbox class="mb-3" v-model="selectAllPromo">
                                    Select All Promo
                                </base-checkbox>


                                <base-input label="Promo Code Selection" v-if="selectAllPromo == false">
                                    <a-select
                                        show-search
                                        mode="multiple"
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        v-model="inputPromoCodes">
                                        <a-select-option v-for="option in promoCodes" :key="option.code" :value="option.code">{{option.code}}</a-select-option>
                                    </a-select> 
                                </base-input>
                            </div>

                            <div class="col-md-6">

                                <base-checkbox class="mb-3" v-model="selectAllBrand">
                                    Select All Brand
                                </base-checkbox>

                                <base-input label="Brand Selection" v-if="selectAllBrand == false">
                                    <a-select
                                        show-search
                                        mode="multiple"
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        v-model="inputBrands">
                                        <a-select-option :key="0" :value="0">Select All</a-select-option>
                                        <a-select-option v-for="option in brands" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select> 
                                </base-input>
                            </div>
                        </div>

                        <!-- <div class="row">
                            <div class="col-md-6">

                                <base-checkbox class="mb-3" v-model="selectAllLocation">
                                    Select All Site
                                </base-checkbox>

                                <base-input label="Site Selection" v-if="selectAllLocation == false">
                                    <a-select
                                        show-search
                                        mode="multiple"
                                        style="width: 100%"
                                        placeholder="Please select"
                                        optionFilterProp="children"
                                        v-model="inputLocations">
                                        <a-select-option :key="0" :value="0">Select All</a-select-option>
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select> 
                                </base-input>
                            </div>

                            
                        </div> -->

                    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
    
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <!-- <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp; -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import * as ExcelJS from "exceljs";
        import { saveAs } from "file-saver";
    
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            components: {
                AdvanceFilter,VueJsonToCsv
            },
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                    selectAllPromo: false,
                    selectAllBrand: false,
                    selectAllLocation: false,
                    inputSite: [],
                    site_type: "ho",
                    siteOptions: [],
                    inputLocations: [],
                    inputPromoCodes: [],
                    inputBrands: [],
                    promoCodes: [],
                    brands: [],
                    locations: [],
                    headerExcelInfo: "",
                    // locationPath: [],
                    inputStatus: '',
                    // statusOptions: [
                    //     {key: 'A', value: 'Active'},
                    //     {key: 'I', value: 'Inactive'},
                    //     {key: 'E', value: 'Expired'},
                    //     {key: '', value: 'All'},
                    // ],
                    // inputSortBy: 'code',
                    sortOptions: [
                        {key: 'code', value: 'Customer Code'},
                        {key: 'name', value: 'Address'},
                    ],
                    promoReportType: 1,
                    currDate: moment().format("L_LT").split(":").join(";"),
                    isShowAddress: false,
                    isShowDetail: true,
                    inputFrom: moment().startOf('month'),
                    inputTo: moment().endOf('month'),
                    monthFormat: 'MM/YYYY',
                    birDateReports: [],
                    toggleAdvanceFilter: false,
                    toggleLabel: "Advanced Filter",
                    advancedFilterParams: {},
                    params: {},
                    advancedFilterVisible: true,
    
                    showSortInfo: 'asc',
                    JsonData: []
                }
            },
            watch: {
                selectAllBrand: function() {
                    if(this.selectAllBrand == true){
                        this.inputBrands = []
                    }
                },
                selectAllPromo: function() {
                    if(this.selectAllPromo == true){
                        this.inputPromoCodes = []
                    }
                },
                selectAllLocation: function() {
                    if(this.selectAllLocation == true){
                        this.inputLocations = []
                    }
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all", null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);

                var promos = await HTTPRequest.getRequest(component_x.endPoint + "promos", null);
                component_x.promoCodes = promos.data
                // component_x.promoCodes.unshift({code: "All"})
    
                var brands = await HTTPRequest.getRequest(component_x.endPoint + "brands", null);
                component_x.brands = brands.data

                // var locations = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all&site_type=branch", null);
                // component_x.locations = locations.data
                // component_x.brands.unshift({name: "All", id: 0})

                // let siteId = secureStorage.getItem("defaultSiteId")
                // this.inputSite = []
                
    
                // let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                // if(site != undefined){
                //     this.site_type = site.site_type
                // }
            },
            computed: {
                ...mapState(['currentProfile', 'endPoint']),
            },
            methods: {
                moment,
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                autoChange(e){
                    if(e.target.value == ''){
                        this.isShowDetail = true
                    }
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advancedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                generateReport: async function () {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    // console.log(filter_header,additional_params,status_header, this.inputSite, this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name))
                    // let filter_header = ''
                    // filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)
                    // if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                    //      let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    //      filter_header = filter_header.concat("Sites: ", sites )
                    // }else{
                    //     let sites = this.siteOptions.map(x => x.name)
                    //     filter_header = filter_header.concat("Sites: All Sites")
                    // }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                
                    let parameters = {
                        "date_from": from_date,
                        "date_to": to_date,
                        // "sites": this.inputLocations.toString(),
                        "promo_codes": this.inputPromoCodes.toString(),
                        "brands": this.inputBrands.toString(),
                        // "order": this.inputSortBy,
                        // "by": this.showSortInfo,
                        // "status": this.inputStatus,
                        // "isShowAddress": this.isShowAddress
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'promo_listing_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        this.spinning = false;
                        return
                    }
                    var siteSpecific = get_request;
                
                    let design_x = 0
                    let design_y = 0


                    // -- rank,product_id , product_name,sales, transaction_count,qty_sold,onhand 
                    if(siteSpecific.length > 0){
                        var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                        // let reportLogo = document.getElementById('reportLogo');
                        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        let headers = [];

                        
                        headers = [
                            [
                                {content: 'Promo Code', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Promo Name', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Start Date', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'End Date', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Item Code', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Description', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Retail Price', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Discount', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Site Count', styles: {halign: 'center', valign: 'auto'}},
                            ]
                        ]
                    

                        for(let x=0; x < siteSpecific.length; x++){
                            this.customerListings = siteSpecific[x].report_details

                            if(x > 0 && this.customerListings.length > 0){
                                doc.addPage();
                            }

                            let reportData = [];

                            if(this.customerListings.length > 0){

                                for(let i=0; i < this.customerListings.length; i++){
                                    let reportLine = this.customerListings[i]
                                    // let basketSize = this.convertToCurrency(Number(reportLine.sales/reportLine.transaction_count))

                                    let detail = []
                                    detail = [
                                        reportLine['Promo Code'],
                                        reportLine['Promo Name'],
                                        reportLine['Start Date'],
                                        reportLine['End Date'],
                                        reportLine['Item Code'],
                                        reportLine['Description'],
                                        reportLine['Retail Price'],
                                        reportLine['Discount'],
                                        reportLine['Site Count']
                                    ]
                                    
                                    reportData.push(Object.assign({}, detail))

                                }
                            }


                            design_x = 330
                            design_y = 200
                            
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Promo Listing Reports")
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                            doc.text(15,30,filteredOptions )

                            // let splitTitle = doc.splitTextToSize("Filtered by: ", 180);
                            // doc.text(15,35,splitTitle);

                            let colStyles = {}

                            colStyles = {
                                0: {cellWidth: 'auto',halign: 'center'},
                                1: {cellWidth: 'auto',halign: 'left'},
                                2: {cellWidth: 'auto',halign: 'left'},
                                3: {cellWidth: 'auto',halign: 'left'},
                                4: {cellWidth: 'auto',halign: 'left'},
                                5: {cellWidth: 'auto',halign: 'left'},
                                6: {cellWidth: 'auto',halign: 'left'},
                                7: {cellWidth: 'auto',halign: 'left'},
                                8: {cellWidth: 'auto',halign: 'left'},
                                9: {cellWidth: 'auto',halign: 'left'},
                            }


                            doc.autoTable({
                                startY: 45,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'auto',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                margin: { bottom: 30 },
                                styles: {
                                    cellPadding: 1.3, fontSize: 10,
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });


                        }
                        // end loop

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        
                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Promo Listing Report", design_x, design_y, i, pageCount)
                        }
                        // await window.open(URL.createObjectURL(doc.output("blob")))
                        doc.save(`PromoListingReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
                },
                getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                        console.log(dataURL)
                    }
                    return img.src = url
                },
                async generateExcel(){
                    const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("Promo Listing Report", {
                        pageSetup:{paperSize: 9}
                    });
    
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''
                    filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)
                    // if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                    //     let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    //     filter_header = filter_header.concat("Sites: ", sites )
                    // }else{
                    //     let sites = this.siteOptions.map(x => x.name)
                    //     filter_header = filter_header.concat("Sites: All Sites")
                    // }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    const data_starts_at_row = 8
    
                    // let reportLogo = document.getElementById('reportLogo');
                
                    // const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    // const imageId2 = workbook.addImage({
                    //     base64: base64Image,
                    //     extension: 'png',
                    // });
    
                    // sheet.addImage(imageId2, {
                    //     tl: { col: 0, row: 0 },
                    //     ext: { width: 61, height: 61 }
                    // });
    
                    sheet.getRow(4).values = [`Promo Listing Report`]
                    sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                    // sheet.getRow(6).values = [`Filtered by: ${filter_header}}`]
                    sheet.getRow(7).values = [`${filteredOptions}`]
                    
                    
                    

                    //custom header
                    
                    sheet.getRow(data_starts_at_row).values = ['Promo Code','Promo Name','Start Date','End Date','Item Code','Description','Retail Price','Discount','Site Count'];
                    sheet.columns = [
                        { key: "Promo Code" , width: 20 },
                        { key: "Promo Name" , width: 20 },
                        { key: "Start Date", width: 15 },
                        { key: "End Date" , width: 20 },
                        { key: "Item Code", width: 15 },
                        { key: "Description", width: 15 },
                        { key: "Retail Price", width: 15 },
                        { key: "Discount", width: 15 },
                        { key: "Site Count", width: 15 },
                    ];

                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    // console.log("details", report_details)
                    // console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0

                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]
                        if(report_detail){
                            let rowData = {"Promo Code": report_detail["Promo Code"],"Promo Name": report_detail["Promo Name"],"Start Date": report_detail["Start Date"],
                                "End Date": report_detail["End Date"],"Item Code": report_detail["Item Code"], 
                                "Description": report_detail["Description"], "Retail Price": report_detail["Retail Price"]
                                , "Discount": report_detail["Discount"],"Site Count": report_detail["Site Count"]
                            }
                            
                        }
                        rowDatas.push(rowData)             

                    }

    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(4).font = { bold: true, size: 16 };
                    sheet.getRow(4).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `CustomerListingReport.xlsx`);
                    });
                    this.JsonData = []
                },
                generateFile: async function() {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    if(this.inputLimit != '' && this.inputLimit != null){
                        filteredOptions = filteredOptions.concat(' ,Top: ',this.inputLimit)
                    } 


                    let parameters = {
                        // "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        // "location": this.inputLocations.toString(),
                        "promo_codes": this.inputPromoCodes.toString(),
                        "brands": this.inputBrands.toString(),
                        // "order": this.inputSortBy,
                        // "by": this.showSortInfo,
                        // "status": this.inputStatus,
                        // "isShowAddress": this.isShowAddress
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'promo_listing_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        this.spinning = false;
                        return
                    }

                    if(get_request.length > 0){
                        let siteSpecific = get_request;

                        let headers = ['Promo Code','Promo Name','Start Date','End Date','Item Code','Description','Retail Price','Discount','Site Count'];
                        let site_specific = [];
    
                        for(let x=0; x < siteSpecific.length; x++){
                            this.customerListings = siteSpecific[x].report_details
    
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
                            if(this.customerListings.length > 0){
                                console.log(this.customerListings.length)
                                let grouper = 'start'
                                for(let i=0; i < this.customerListings.length; i++){
                                    let reportLine =this.customerListings[i]
                                    let detail = []
                                    
                                    detail = [
                                        reportLine['Promo Code'],
                                        reportLine['Promo Name'],
                                        reportLine['Start Date'],
                                        reportLine['End Date'],
                                        reportLine['Item Code'],
                                        reportLine['Description'],
                                        reportLine['Retail Price'],
                                        reportLine['Discount'],
                                        reportLine['Site Count']
                                    ]
                                   
                                    reportData.push(Object.assign({}, detail))
                                }
    
                            }
    
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            // reportData.push(["Customer Listing Report" + "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
                            
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                    }
                    this.spinning = false;
                },
                clearJsonData(){
                 this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>
